import TeamMemberProfile from './TeamMemberProfile';

export default TeamMemberProfile;
